<div class="panel panel-default panel--shadow margin-bottom-48">
  <div class="panel-body">
    <div class="flex-always flex--align-start flex--space-between margin-bottom-16">
      <h3 class="margin-top-0 text-dark-blue"
        [innerHTML]="appCopy.panelHeader['tranvelHandsFreeTitle'+selectedLanguage]">Travel hands free on your return
      </h3>
    </div>

    <!-- if CCD -->
    <p
      [innerHTML]="appCopy.panelHeader['travelHandsFreeDescriptionArrival'+selectedLanguage].replace('%s', arrivalAirport.airportCode)">
      The Arrival service is available when you return to {{arrivalAirport.airportCode}}. Confirm your return flight and
      have your bags delivered after landing.
    </p>

    <div class="flex-always flight-details margin-top-24 margin-bottom-24">
      <div class="flex-1">
        {{ departureAirport.airportCode }} to {{arrivalAirport.airportCode}} • {{ flightReturnDate | date:'MMM d yyyy' :'' : languageCode }}
      </div>
      <button class="btn btn-ghost btn-text-ghost" (click)="returnToPreviouseStep()"
        [innerHTML]="appCopy.panelHeader['buttonEdit'+selectedLanguage]">edit</button>
    </div>

    <form class="flight-results-filter row margin-bottom-24" novalidate>

      <div class="col-md-12">
        <!-- *ngIf="direction !== 2" -->
        <div class="radio-toggle radio-toggle--3" style="background-color: #DBE5FD;">
          <div class="active-item-bg" [style.transform]="'translateX(' + activeRadioIndex * 100 + '%)'"></div>
          <div class="flex-always">
            <div class="radio radio-toggle__item">
              <input type="radio" name="flightStops" ngControl="flightStops" id="flightDirect" value="0"
                [(ngModel)]="legsFilter" (ngModelChange)="filterLegChanged($event, 'direct')"
                [disabled]="flightSelectionDisabled">
              <label class="flight-stop step_radio_label" for="flightDirect">{{
                appCopy.panelHeader['buttonFlightDirect'+selectedLanguage]
                }}</label>
            </div>
            <div class="radio radio-toggle__item">
              <input type="radio" name="flightStops" ngControl="flightStops" id="flightOneStop" value="1"
                [(ngModel)]="legsFilter" (ngModelChange)="filterLegChanged($event, 'oneStop')"
                [disabled]="flightSelectionDisabled">
              <label class="flight-stop step_radio_label" for="flightOneStop">{{
                appCopy.panelHeader['buttonFlightOneStop'+selectedLanguage] }}</label>
            </div>
            <div class="radio radio-toggle__item">
              <input type="radio" name="flightStops" ngControl="flightStops" id="flightTwoStop" value="2"
                [(ngModel)]="legsFilter" (ngModelChange)="filterLegChanged($event, 'twoStop')"
                [disabled]="flightSelectionDisabled">
              <label class="flight-stop step_radio_label" for="flightTwoStop">{{
                appCopy.panelHeader['buttonFlightTwoStop'+selectedLanguage] }}</label>
            </div>
          </div>
        </div>
      </div>
      <!-- <a *ngIf="flightSelectionDisabled" href="javascript:void(0)" (click)="cancelClick($event)">Cancel</a> -->
    </form>

    <div class="loader-container" *ngIf="flightResultsLoading || flightSelectionInprogress">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>

    <div *ngIf="!flightResultsLoading && !flightSelectionInprogress">

      <div *ngIf="flightResults.length === 0 && direction === 1">
        <div class="alert alert-ghost flex-always margin-bottom-8">
          <div class="sprite sprite--alert-checklist margin-right-16"></div>
          <div>
            <h3 *ngIf="!isMultiLegFlight" class="margin-top-0 margin-bottom-0">{{
              appCopy.panelHeader['errorTextIsNotMultiLegFlight'+selectedLanguage] }}</h3>
            <h3 *ngIf="isMultiLegFlight" class="margin-top-0 margin-bottom-0">{{
              appCopy.panelHeader['errorText'+selectedLanguage] }}</h3>
            <p>{{ appCopy.panelHeader['errorTextFlightDirect'+selectedLanguage] }}</p>
            <!-- <a *ngIf="!isMultiLegFlight" href="javascript:void(0)" (click)="callMultiLegApi($event)">Search non-direct flights?</a> -->
          </div>
        </div>
        <!-- <a class="link" routerLink='/flight-finder/search?start-booking=true'>{{
          appCopy.panelHeader['linkSearchAgain'+selectedLanguage]
          }}</a> -->
      </div>

      <div *ngIf="flightResults.length === 0 && direction === 2">
        <div class="alert alert-ghost flex-always margin-bottom-8">
          <div class="sprite sprite--alert-checklist margin-right-16"></div>
          <div>
            <h3 class="margin-top-0 margin-bottom-0">{{ appCopy.panelHeader['errorText'+selectedLanguage] }}
            </h3>
            <p>{{ appCopy.panelHeader['errorTextFlightOneStop'+selectedLanguage] }}</p>
          </div>
        </div>
        <!-- <a class="link" routerLink='/flight-finder/search?start-booking=true'>{{
          appCopy.panelHeader['linkSearchAgain'+selectedLanguage]
          }}</a> -->
      </div>

      <!-- .slice(0, showMoreOptions ? flightResults.length : 3) -->
      <ul class="list-unstyled flight-results" *ngIf="flightResults.length > 0">
        <li *ngFor="let item of flightResults.slice(0, showRecords < 20 ? showRecords : 20); let i = index"
          id="flightResultItem{{i}}" class="reveal" [class.is-open]="item.flightInfo.id === selectedFlightId">

          <div class="reveal__toggle flight-item panel panel--shadow" tabindex="0"
            (click)="toggleSelectedItem($event, item.flightInfo)"
            (keyup.enter)="toggleSelectedItem($event, item.flightInfo.id)">
            <div class="panel-body flex-always">
              <div
                [ngClass]="'hidden-xs airline-logo airline-logo--' + item.flightStatusDetails[0].airlineCode.replace('*', '')">
              </div>
              <div class="flex-lg flex__item--grow">
                <div class="flex__item--equal">
                  <p style="text-transform: none;">{{ item.flightStatusDetails[0].airlineName }}</p>
                  <p><span class="hidden-xs">{{ appCopy.panelHeader['titleFlight'+selectedLanguage] }}
                    </span>{{
                    item.flightStatusDetails[0].airlineCodeDisplayName }}{{
                    item.flightStatusDetails[0].flightNumber }}
                    <span id="info" (click)="showLinkedFlights($event, item)">
                      <span class="icon-information icon-black icon_18"></span>
                    </span>
                  </p>
                </div>
                <div class="flex__item--equal" *ngIf="item.flightStatusDetails.length > 1">
                  <p class="visible-lg-block">{{ appCopy.panelHeader['titleStops'+selectedLanguage] }}</p>
                  <p class="flex-always text-extra-bold">
                    {{ item.flightStatusDetails[0].departureAirport.airportCode }}
                    <ng-container *ngFor="let leg of item.flightStatusDetails">
                      <span class="leg-divider"></span>
                      {{ leg.arrivalAirport.airportCode }}
                    </ng-container>
                  </p>
                </div>
              </div>
              <div class="flex-divider margin-right-0 hidden-sm hidden-xs"></div>
              <div class="flex-lg flex-md flight-item__departure">
                <p>{{ appCopy.panelHeader['titleDeparts'+selectedLanguage] }}</p>
                <h4 class="text-extra-bold margin-top-0 margin-bottom-0">{{
                  item.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal | amDateFormat:
                  'HH:mm' }}
                </h4>
              </div>
            </div>
          </div>

          <div class="reveal__content">
            <app-flight-details *ngIf="item.flightInfo.id === selectedFlightId && showFlightDetails" [flightData]="item"
              [appAirportCopy]="appAirportCopy" [appCopy]="appCopy" [selectedLanguage]="selectedLanguage"
              [languageCode]="languageCode" (cancelFlight)="handleCancelFlight($event)"
              (confirmFlight)="handleConfirmFlight($event)" [isFlyback]="true">
            </app-flight-details>
          </div>
        </li>
      </ul>

      <!-- <div class="margin-top-24" *ngIf="flightResults.length > 0 && direction === 2">
              <div class="alert alert-ghost flex-always margin-bottom-8">
                <div class="sprite sprite--alert-checklist margin-right-16"></div>
                <div>
                  <h3 class="margin-top-0 margin-bottom-0">Flight not found?</h3>
                  <p>If you can't see your flight? It might have a stopover.<br> Search again with the departure airport and
                    airline for the plane that arrives in the UK.</p>
                </div>
              </div>
              <a class="link" routerLink='/flight-finder/search'>Search again</a>
            </div> -->
      <!-- <button type="button" class="btn btn-ghost btn-primary btn-block">Show more</button> -->
    </div>

    <ng-template [ngIf]="!flightResultsLoading && flightResults.length !== 0 && showRecords < 20  && showRecords < flightResults.length">

      <button type="button" class="btn btn-ghost border-0 margin-auto margin-top-24" (click)="showMore()">
        <span [innerHTML]="appCopy.panelHeader['showMore'+selectedLanguage]">
          show more
        </span>
      </button>
    </ng-template>

    <ng-template [ngIf]="!flightResultsLoading && showRecords === 20 && pagingArr.length > 0">
      <div class="paging-container">
        <button class="btn btn-sm btn-white" [class.invisible]="activeSetIndex === 1"
          (click)="handleResultPageClick('prev')"><i class="icon">chevron_left</i></button>

        <div class="radio-toggle-wrapper"
          [style.width]="((pagingArr.length <= pageSetSize ? pagingArr.length * 50 : 200) + 32) + 'px'">
          <div class="radio-toggle" [ngStyle]="{
            'width': (pagingArr.length * 50) + 'px',
            'transform': 'translateX(' + ((1 - activeSetIndex) * 200) + 'px)'
          }">
            <div class="active-item-bg" [style.transform]="'translateX(' + activeRadioIndex * 100 + '%)'"></div>
            <div class="flex-always">
              <div class="radio radio-toggle__item" *ngFor="let item of pagingArr; let i = index">
                <input type="radio" name="resultPage" ngControl="resultPage" [id]="item.type" [value]="item.value"
                  [(ngModel)]="selectedPage" (ngModelChange)="handleResulPageNumberClick(item)">
                <label class='pagination_number_label' [for]="item.type">{{item.value}}</label>
              </div>
            </div>
          </div>
        </div>

        <button class="btn btn-sm btn-white" [class.invisible]="activeSetIndex * pageSetSize >= pagingArr.length"
          (click)="handleResultPageClick('next')"><i class="icon">chevron_right</i></button>
      </div>
    </ng-template>

    <button type="button" [ngClass]="{ Buttonloading: false }"
      class="btn btn-default margin-top-24  margin-auto btn-block" (click)="abortFlyback()" [disabled]="false">
      <span [innerHTML]="appCopy.panelHeader['skipCantFindFlightButton'+selectedLanguage]">Skip - I can’t find my
        flight</span>
    </button>

  </div>
</div>
